import type {CommonProps} from './types';

const CalendarPublished = ({
  color = 'currentColor',
  size = 14,
  ...rest
}: CommonProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6.6 9.8a3.2 3.2 0 106.4 0 3.2 3.2 0 00-6.4 0z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.23 8.87l-1.55 2.07a.4.4 0 01-.6.04l-.8-.8M5 9.8H1.8A.8.8 0 011 9V2.6a.8.8 0 01.8-.8H9a.8.8 0 01.8.8V5"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 4.2h8.8"
      stroke={color}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M3.4 2.6V1M7.4 2.6V1"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CalendarPublished;
